import {Box, Typography} from "@mui/material";
import React from "react";
import TicketsIcon from "../../../../assets/icons/ticketsIcon";

interface TicketListHeaderProps {
    activeTickets: string;
    activeTotalCount: number | undefined;
    closedTotalCount: number | undefined;
}

const TicketListHeader: React.FC<TicketListHeaderProps> = ({
                                                               activeTickets,
                                                               activeTotalCount,
                                                               closedTotalCount,
                                                           }) => {
    return (
        <Box className="flex flex-row items-center">
            <Typography className="md:p-2 py-3 px-1">
                <TicketsIcon
                    style={{background: "black", width: "18px", height: "18px"}}
                    fill={"#fff"}
                />
            </Typography>
            <Typography className="flex items-center text-[#0077B2]">
                Tickets{" "}
                {activeTickets === "active"
                    ? activeTotalCount != undefined && "(" + activeTotalCount + ")"
                    : closedTotalCount != undefined && "(" + closedTotalCount + ")"}
            </Typography>
        </Box>
    );
};

export default TicketListHeader;
